import App from '@triage-help/components/App';

export default App;
